import React, { FunctionComponent } from 'react';
import { Grid } from '@rbx/ui';
import useHeadingGroupStyles from '@modules/ui/shared/styles/HeadingGroup.styles';
import OpenCloudAPIContent from '../../../utils/interfaces/OpenCloudAPIContent';
import SummaryContainer from './SummaryContainer';
import OpenCloudEndpointsContainer from './OpenCloudEndpointsContainer';
import OpenCloudObjectsContainer from './OpenCloudObjectsContainer';

export interface OpenCloudContentProps {
  content: OpenCloudAPIContent;
}

const OpenCloudContent: FunctionComponent<React.PropsWithChildren<OpenCloudContentProps>> = ({
  content,
}) => {
  const {
    classes: { root },
  } = useHeadingGroupStyles();
  const serverUrl = content.servers?.[0]?.url;
  const { endpoints, objects } = content;

  return (
    <Grid container direction='column' className={root}>
      <Grid item XSmall>
        <SummaryContainer description={content.description} />
      </Grid>
      <Grid item XSmall>
        <OpenCloudEndpointsContainer endpoints={endpoints} serverUrl={serverUrl} />
      </Grid>
      <Grid item XSmall>
        <OpenCloudObjectsContainer objects={objects} />
      </Grid>
    </Grid>
  );
};

export default OpenCloudContent;
